module.exports = __webpack_public_path__ + "media/wrongAnswer.ef5dc189.mp3";